import FillMethod from './FillMethod'
import Logger from '../Log'
import { ecpmOrDefault, loadScript, playerDims } from '../utils'

const Log = Logger.for('VidazooFillMethod')

export default class VidazooFillMethod extends FillMethod {
  constructor (bidder) {
    super('vidazoo', bidder, 'video', ecpmOrDefault(bidder.params.ecpm, 1))
  }

  fill (slot, media) {
    return new Promise((resolve, reject) => {
      Log.debug('Running vidazoo fill method')

      const dims = playerDims(media, { vastXml: '<vast>' })
      // These are important to ensure player size max and prevent an odd loading shift animation
      slot.node().style.width = dims[0] + 'px'
      slot.node().style.margin = 'auto'
      slot.node().blah = 'true'

      loadScript('//static.vidazoo.com/basev/vwpt.js', slot.node(), { 'data-widget-id': this._bidder.params.widgetId })
        .then(script => {
          Log.debug('Vidzoo script loaded')
          slot.resource(script)

          // script loaded, allow time for an ad to be retrieved
          setTimeout(() => {
          // Vidazoo creates a child div to house their video player if an ad is available
            if (!slot.node().querySelector('div')) {
              slot.resetNode()
              return resolve({ cpm: 0 })
            }

            Log.debug('Found vidazoo desktop div, think we filled')

            return resolve({
              width: dims[0],
              height: dims[1],
              cpm: this.estValue()
            })
          }, 3000)
        })
    })
  }
}
